import { render, staticRenderFns } from "./Produkt.vue?vue&type=template&id=54a30e67&"
import script from "./Produkt.vue?vue&type=script&lang=js&"
export * from "./Produkt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports